<template>
  <b-container>
    <LoadingIndicator 
      v-if="loading"
      topic="Apps"
    />
    <div v-else class="my-5 widget">
      <b-table
        hover
        responsive
        class="custom-table"
        :items="tenants"
        :fields="fields"
        @row-clicked="selectTenant"
      >
        <template v-slot:cell(logoUrl)="data">
          <div v-if="data.item.logoUrl" class="text-center">
            <img
              :src="data.item.logoUrl"
              :alt="data.item.tenantName"
              :title="data.item.tenantName"
            />
          </div>
        </template>
        <template v-slot:cell(projectNames)="data">
          <span v-if="data.item.projectNames.length > 0">
            {{ data.item.projectNames.join(", ") }}
          </span>
          <span v-else> None </span>
        </template>
      </b-table>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import authMixin from "@/mixins/auth-mixin.js";
export default {
  name: "ChooseTenant",
  mixins: [authMixin],
  mounted() {
    if (!this.accountUser) {
      this.defaultRedirect();
    }
    this.userId = this.accountUser.userId;
    this.nextUrl = this.$route.query.returnUrl;
    axios
      .get(
        `${this.$api_url}/users/${this.userId}/tenant-choice-list`,
        this.getReqConfig()
      )
      .then((response) => {
        this.tenants = response.data;
      })
      .catch((err) => {})
      .finally(() => {
        this.loading = false;
      });
  },
  data() {
    return {
      loading: true,
      userId: "",
      tenants: [],
      errors: [],
      nextUrl: null,
      fields: [
        { key: "logoUrl", label: "", class: "table__logo" },
        { key: "tenantName", label: "Account" },
        { key: "projectNames", label: "Projects" },
      ],
    };
  },
  methods: {
    selectTenant(item) {
      this.$store.dispatch("setTenantId", item.tenantId).then(() => {
        axios
          .get(
            `${this.$api_url}/users/${this.userId}/permissions`,
            this.getReqConfig()
          )
          .then((response) => {
            let actions = [];
            if (response.data.tenantId) {
              actions.push(
                this.$store.dispatch("setTenantId", response.data.tenantId)
              );
            }
            actions.push(
              this.$store.dispatch("setUser", response.data.userAccount)
            );
            Promise.all(actions).then(() => {
              this.defaultRedirect(this.nextUrl);
            });
          })
          .catch((err) => {
            console.error(err);
          })
          .finally(() => {});
      });
    },
  },
  computed: {},
};
</script>

<style lang="scss">
td.table {
  &__logo {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    // background: #76a2cd;
    width: 200px;

    img {
      max-width: 100px;
    }
  }
}
</style>